import { z } from "zod";

export const addGroupMembersSchema = z
	.object({
		user_ids: z.array(z.uuid()).min(1, { message: "At least one user must be provided" }),
	})
	.strict();

export type AddGroupMembersPayload = z.infer<typeof addGroupMembersSchema>;
